import PropTypes from 'prop-types';
import { Box, Flex } from 'theme-ui';

import { DropdownOption } from './Dropdown.Option';
import { DropdownSelected } from './Dropdown.Selected';
import { useDropdown } from './useDropdown';
import { themed } from './Dropdown.theme';

export const Dropdown = themed(
  ({
    theme,
    variant = 'default',
    initial,
    children,
    label = '',
    maxHeight = '400px',
    onSelected = () => {},
    onSelecting = () => {},
    inputRef,
    ...props
  }) => {
    const [{ dropdownRef, Component, selecting }] = useDropdown({
      variant,
      initial,
      children,
      label,
      onSelected,
      onSelected,
      ...props,
    });

    return (
      <Flex
        data-comp={Dropdown.displayName}
        ref={dropdownRef}
        {...props}
        sx={{
          ...theme[variant]?.wrapper,
          ...props.sx,
        }}
      >
        {/* Render selected option */}
        {Component.Selected}

        {/* Render drawer with options */}
        <Box sx={theme[variant]?.drawerWrapper}>
          <Flex
            data-comp="DropdownDrawer"
            sx={{
              ...theme[variant]?.drawer,
              // maxHeight: selecting ? maxHeight : '0px',
              display: selecting ? 'block' : 'none',
            }}
          >
            <Box
              data-comp="DropdownScroll"
              role="listbox"
              sx={{
                ...theme[variant]?.scroll,
              }}
            >
              {/* Render options */}
              {Component.Options}
            </Box>
          </Flex>
        </Box>
      </Flex>
    );
  }
);

Dropdown.displayName = 'Dropdown';
Dropdown.Option = DropdownOption;
Dropdown.Selected = DropdownSelected;

Dropdown.propTypes = {
  initial: PropTypes.any.isRequired,
  children: PropTypes.node,
  maxHeight: PropTypes.string, // pixels amount
  onSelected: PropTypes.func,
  onSelecting: PropTypes.func,
};
